/**
 * Farlo UI | CRM
 *
 * @author Farlo
 */

// Farlo UI MC
class FarloUiCrm {
	constructor(_config) {
		var _self = this;
		var _instance = null;
		var crmAjaxHandler = null;

		if (typeof farloUiMcAjaxHandler !== 'undefined') {
			crmAjaxHandler = farloUiMcAjaxHandler;
		} else if (typeof farloUiSpektrixAjaxHandler !== 'undefined') {
			crmAjaxHandler = farloUiSpektrixAjaxHandler;
		} else {
			crmAjaxHandler = farloAjaxHandler;
		}

		this.config = {
			formId: '',
			nextBtn: '.farlo-ui-crm__next',
			prevBtn: '.farlo-ui-crm__prev',
			navContainer: '.farlo-ui-crm__nav',
			closeBtn: '.farlo-ui-crm__close',
			tabClass: '.farlo-ui-crm__tab',
			stepsClass: '.farlo-ui-crm__step',
			initData: null,
			startPage: 0,
			validateFirst: false,
		};

		this.params = {
			initialised: false,
			currentStep: 0,
			totalSteps: 0,
			emailHash: '',
			data: new FormData(),
		};

		this.customEvent = function (_name, _detail) {
			var customEvent = new CustomEvent(_name, { detail: _detail });
			window.dispatchEvent(customEvent);
		};

		this.customEvents = {
			farloSignupFormStarted: new CustomEvent('farloSignupFormStarted', {
				detail: { event: 'Signup Form Started', data: _self.page_data },
			}),
			farloSignupStageComplete: new CustomEvent(
				'farloSignupStageComplete',
				{
					detail: {
						event: 'Signup Stage Complete',
						data: _self.page_data,
					},
				}
			),
			farloSignupFormComplete: new CustomEvent(
				'farloSignupFormComplete',
				{
					detail: {
						event: 'Signup Form Complete',
						data: _self.page_data,
					},
				}
			),
		};

		this.init = function (config) {
			if (_self.params.initialised) {
				_self.toggleForm();
			}

			if (
				window._farlo &&
				window._farlo.events &&
				typeof window._farlo.events.push === 'function'
			) {
				window._farlo.events.push('Signup', 'Started');
			}

			_self.customEvent('farloSignupFormStarted', {
				event: 'Signup Form Started',
			});

			if (typeof config === 'string') {
				_self.config.formId = config;
			} else if (typeof config === 'object') {
				for (var key in config) {
					if (config.hasOwnProperty(key)) {
						_self.config[key] = config[key];
					}
				}
			} else {
				console.log('No Form ID set');
				return false;
			}

			_instance = document.getElementById(_self.config.formId);
			if (!_instance) return;

			var steps = _instance.querySelectorAll(_self.config.stepsClass);
			_self.params.totalSteps = steps.length;

			if (_self.params.totalSteps === 1 && steps[0]) {
				steps[0].style.display = 'none';
			}

			if (_self.config.initData) {
				for (var i in _self.config.initData) {
					if (_self.config.initData.hasOwnProperty(i)) {
						var el = _instance.querySelector('#' + i);
						if (el) {
							if (el.type === 'checkbox') {
								el.checked = _self.config.initData[i];
							} else {
								el.value = _self.config.initData[i];
							}
						}
					}
				}
				if (_self.config.validateFirst) {
					_self.nextPrev(1);
				} else {
					_self.showPage(_self.config.startPage);
				}
			} else {
				_self.showPage(_self.config.startPage);
			}

			if (!_instance.classList.contains('crm-inline')) {
				_self.toggleForm();
			}

			var nextBtn = _instance.querySelector(_self.config.nextBtn);
			var prevBtn = _instance.querySelector(_self.config.prevBtn);
			var closeBtns = _instance.querySelectorAll(_self.config.closeBtn);

			if (nextBtn) {
				nextBtn.addEventListener('click', function () {
					_self.nextPrev(1);
				});
			}
			if (prevBtn) {
				prevBtn.addEventListener('click', function () {
					_self.nextPrev(-1);
				});
			}
			if (closeBtns && closeBtns.length > 0) {
				for (var j = 0; j < closeBtns.length; j++) {
					closeBtns[j].addEventListener('click', function (e) {
						e.stopImmediatePropagation();
						_self.toggleForm();
					});
				}
			}
			_self.params.initialised = true;
		};

		this.toggleForm = function () {
			if (!_instance) return;
			if (_instance.style.display === 'flex') {
				_instance.style.display = 'none';
				document.body.classList.remove('farlo-crm-open');
			} else {
				_instance.style.display = 'flex';
				document.body.classList.add('farlo-crm-open');
			}
		};

		this.prepareMailchimpData = function (x) {
			_self.params.data.append('action', 'farlo-ui-modify-subscriber');
			_self.params.data.append('hash', _self.params.emailHash);

			var param_name;
			_self.page_data = {};

			var tab = x[_self.params.currentStep];
			if (!tab) return;

			var inputs = tab.querySelectorAll(
				'.farlo-ui-crm__textbox, .farlo-ui-crm__hidden'
			);
			for (var i = 0; i < inputs.length; i++) {
				var el = inputs[i];
				if (el.value !== '') {
					param_name = 'FARLO_UI_MC_' + el.id;
					_self.params.data.append(param_name, el.value);
					_self.page_data[param_name] = el.value;
				}
			}

			var singleCheckboxes = tab.querySelectorAll(
				'.farlo-ui-crm__form-item-single_checkbox'
			);
			for (var s = 0; s < singleCheckboxes.length; s++) {
				var field = singleCheckboxes[s];
				var el2 = field.querySelector('.farlo-ui-crm__input');
				if (el2 && el2.checked) {
					param_name = 'FARLO_UI_MC_' + el2.id;
					_self.params.data.append(param_name, el2.value);
					_self.page_data[param_name] = el2.value;
				}
			}

			var singleChoices = tab.querySelectorAll(
				'.farlo-ui-crm__form-item-single_choice_field'
			);
			for (var sc = 0; sc < singleChoices.length; sc++) {
				var field2 = singleChoices[sc];
				var choiceEl = field2.querySelector('.farlo-ui-crm__choice');
				var id = choiceEl
					? choiceEl.id.replace('farlo-ui-crm__choice-', '')
					: '';
				var selectedLabels = [];
				var checkboxes = field2.querySelectorAll(
					'.farlo-ui-crm__input'
				);
				for (var c = 0; c < checkboxes.length; c++) {
					if (checkboxes[c].checked) {
						var label = field2.querySelector(
							"label[for='" + checkboxes[c].id + "']"
						);
						if (label) selectedLabels.push(label.innerText);
					}
				}
				param_name = 'FARLO_UI_MC_' + id;
				_self.params.data.append(param_name, selectedLabels.toString());
				_self.page_data[param_name] = selectedLabels.toString();
			}

			if (
				window._farlo &&
				window._farlo.events &&
				window._farlo.events.generic
			) {
				window._farlo.events.generic(_self.page_data);
			}
			if (
				window._farlo &&
				window._farlo.events &&
				typeof window._farlo.events.push === 'function'
			) {
				window._farlo.events.push(
					'Signup',
					'Stage Complete',
					_self.params.currentStep + 1
				);
			}

			_self.customEvent('farloSignupStageComplete', {
				event: 'Signup Stage Complete',
				data: _self.page_data,
				stage: _self.params.currentStep + 1,
			});

			if (
				window._farlo &&
				window._farlo.storage &&
				typeof window._farlo.storage.set === 'function'
			) {
				window._farlo.storage.set('_farlo_crm', _self.page_data);
			}
		};

		this.prepareDotDigitalData = function (x) {
			var email = '';
			var dataFields = [];
			var tab = x[_self.params.currentStep];
			if (!tab) return;

			var inputs = tab.querySelectorAll(
				'.farlo-ui-crm__input, .farlo-ui-crm__textbox, .farlo-ui-crm__hidden'
			);
			for (var i = 0; i < inputs.length; i++) {
				var el = inputs[i];
				if (el.type === 'email') {
					email = el.value;
				} else if (el.type === 'checkbox') {
					continue;
				} else if (el.value !== '') {
					dataFields.push({ key: el.id, value: el.value });
				}
			}

			var singleChoiceFields = tab.querySelectorAll(
				'.farlo-ui-crm__form-item-single_choice_field'
			);
			for (var j = 0; j < singleChoiceFields.length; j++) {
				var field = singleChoiceFields[j];
				var selected = field.querySelector(
					'.farlo-ui-crm__input:checked'
				);
				if (selected) {
					var key = field.id || '';
					var choiceEl = field.querySelector('.farlo-ui-crm__choice');
					if (!key && choiceEl)
						key = choiceEl.id.replace('farlo-ui-crm__choice-', '');
					dataFields.push({ key: key, value: selected.value });
				}
			}

			var multipleChoiceFields = tab.querySelectorAll(
				'.farlo-ui-crm__form-item-multiple_choice_field'
			);
			for (var k = 0; k < multipleChoiceFields.length; k++) {
				var field2 = multipleChoiceFields[k];
				var checkedBoxes = field2.querySelectorAll(
					'.farlo-ui-crm__input:checked'
				);
				var values = [];
				for (var cb = 0; cb < checkedBoxes.length; cb++) {
					values.push(checkedBoxes[cb].value);
				}
				if (values.length > 0) {
					var key2 = field2.id || '';
					var choiceEl2 = field2.querySelector(
						'.farlo-ui-crm__choice'
					);
					if (!key2 && choiceEl2)
						key2 = choiceEl2.id.replace(
							'farlo-ui-crm__choice-',
							''
						);
					dataFields.push({ key: key2, value: values.join(', ') });
				}
			}

			_self.params.data.append('action', 'farlo-ui-dd-modify-contact');
			_self.params.data.append('email', email);
			_self.params.data.append('dataFields', JSON.stringify(dataFields));

			if (
				window._farlo &&
				window._farlo.events &&
				typeof window._farlo.events.push === 'function'
			) {
				window._farlo.events.push(
					'Signup',
					'Stage Complete',
					_self.params.currentStep + 1
				);
			}
			_self.customEvent('farloSignupStageComplete', {
				event: 'Signup Stage Complete',
				data: { email: email, dataFields: dataFields },
				stage: _self.params.currentStep + 1,
			});
		};

		this.submitData = function (n, x) {
			var el = document.getElementById(_self.config.formId);
			if (!el) return;
			var isSpektrix = el.classList.contains('farlo-ui-crm__spektrix');
			var isMailchimp = el.classList.contains('farlo-ui-crm__mailchimp');

			_self.params.data.append('nonce', crmAjaxHandler.nonce);

			if (isMailchimp) {
				_self.prepareMailchimpData(x);
			} else if (isSpektrix) {
				_self.prepareDotDigitalData(x);
			} else {
				_self.prepareMailchimpData(x);
			}

			fetch(crmAjaxHandler.ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				body: _self.params.data,
			})
				.then(function (response) {
					return response.json();
				})
				.then(function (data) {
					if (!data || !data.success) {
						throw new Error(
							'Request failed with status ' +
								(data && data.detail ? data.detail : 'unknown')
						);
					}
					if (data.data && data.data.email_hash) {
						_self.params.emailHash = data.data.email_hash;
					}

					var currentTab = x[_self.params.currentStep];
					if (currentTab) {
						currentTab.classList.remove('loading');
						currentTab.style.display = 'none';
					}
					_self.params.currentStep = _self.params.currentStep + n;
					_self.params.data = new FormData();
					_self.showPage(_self.params.currentStep);
				});
		};

		this.showPage = function (n) {
			if (!_instance) return;
			var nav = _instance.querySelector(_self.config.navContainer);
			if (nav) nav.style.display = 'flex';

			var x = _instance.querySelectorAll(_self.config.tabClass);
			if (!x[n]) return;
			x[n].style.display = 'block';

			var prevBtn = _instance.querySelector(_self.config.prevBtn);
			var nextBtn = _instance.querySelector(_self.config.nextBtn);

			if (n === 0 && prevBtn) prevBtn.style.display = 'none';
			else if (prevBtn) prevBtn.style.display = 'inline';

			if (n === x.length - 2 && nextBtn) nextBtn.innerHTML = 'Submit';
			else if (nextBtn) nextBtn.innerHTML = 'Next';

			if (n === x.length - 1 && nav) nav.style.display = 'none';

			_self.indicatorStep(n);
		};

		this.nextPrev = function (n) {
			if (n === 1 && !_self.validatePage()) {
				return false;
			}
			var x = _instance.querySelectorAll(_self.config.tabClass);
			if (!_instance || !x[_self.params.currentStep]) return;

			if (n === 1) {
				x[_self.params.currentStep].classList.add('loading');
				_self.submitData(n, x);
			} else {
				x[_self.params.currentStep].style.display = 'none';
				_self.params.currentStep = _self.params.currentStep + n;
				_self.showPage(_self.params.currentStep);
			}
		};

		this.validatePage = function () {
			var valid = true;
			if (!_instance) return valid;

			var x = _instance.querySelectorAll(_self.config.tabClass);
			var currentTab = x[_self.params.currentStep];
			if (!currentTab) return valid;

			var inputs = currentTab.getElementsByTagName('input');
			for (var i = 0; i < inputs.length; i++) {
				var input = inputs[i];
				if (input.type === 'email') {
					if (
						!(
							window._farlo &&
							window._farlo.helpers &&
							window._farlo.helpers.validators &&
							window._farlo.helpers.validators.email &&
							window._farlo.helpers.validators.email(input.value)
						)
					) {
						input.className += ' invalid';
						valid = false;
					} else if (input.classList) {
						input.classList.remove('invalid');
					}
				} else if (
					input.type === 'checkbox' &&
					input.required &&
					!input.checked
				) {
					input.className += ' invalid';
					valid = false;
				} else if (input.value === '' && input.required) {
					input.className += ' invalid';
					valid = false;
				} else if (input.classList) {
					input.classList.remove('invalid');
				}
			}

			if (valid) {
				var steps = _instance.querySelectorAll(_self.config.stepsClass);
				if (steps[_self.params.currentStep]) {
					steps[_self.params.currentStep].className += ' finish';
				}
			}
			return valid;
		};

		this.indicatorStep = function (n) {
			if (!_instance) return;
			if (n < _self.params.totalSteps) {
				var steps = _instance.querySelectorAll(_self.config.stepsClass);
				for (var i = 0; i < steps.length; i++) {
					steps[i].className = steps[i].className.replace(
						' active',
						''
					);
				}
				if (steps[n]) steps[n].className += ' active';
			} else {
				if (
					window._farlo &&
					window._farlo.events &&
					typeof window._farlo.events.push === 'function'
				) {
					window._farlo.events.push('Signup', 'Complete');
				}
				_self.customEvent('farloSignupFormComplete', {
					event: 'Signup Form Complete',
					data: _self.page_data,
				});
			}
		};

		_self.init(_config);
	}
}

export default FarloUiCrm;
